import Nwiz from "@/assets/projects/nwiz.png";
import SnipNest from "@/assets/projects/snipnest.png";
import GriffinekErettsegiznek from "@/assets/projects/griffinek-erettsegiznek.png";

export const PROJECTS = [
  {
    name: "Griffinék Érettségiznek",
    description: {
      en: "AI-voiced Family Guy dialogues teaching Hungarian high school exam topics, posted as short videos on TikTok.",
      de: "KI-vertonte Family-Guy-Dialoge, die ungarischen Abiturstoff vermitteln, als Kurzvideos auf TikTok.",
      hu: "Mesterséges intelligenciával szinkronizált Family Guy párbeszédek, amelyek az érettségi anyagát tanítják, rövid videókként TikTokon.",
    },
    repo: "https://www.tiktok.com/@griffinek_erettsegiznek",
    demo: "https://www.tiktok.com/@griffinek_erettsegiznek",
    image: GriffinekErettsegiznek,
  },
  {
    name: "SnipNest",
    description: {
      en: "A platform that allows you to search, save, and share code snippets with others.",
      de: "Eine Plattform, die es Ihnen ermöglicht, Code-Snippets zu suchen, zu speichern und mit anderen zu teilen.",
      hu: "Egy platform, amely lehetővé teszi kódrészletek keresését, mentését és megosztását másokkal.",
    },
    repo: "https://github.com/itsbrunodev/snipnest#readme",
    demo: "https://snipnest.dev",
    image: SnipNest,
  },
  {
    name: "nwiz",
    description: {
      en: "A tool for generating Cisco IOS scripts from a network topology you build or import.",
      de: "Ein Tool zum Generieren von Cisco IOS-Skripten aus einer selbst erstellten oder importierten Netzwerktopologie.",
      hu: "Egy eszköz Cisco IOS szkriptek generálására egy Ön által felépített vagy importált hálózati topológiából.",
    },
    repo: "https://github.com/itsbrunodev/nwiz#readme",
    demo: "https://nwiz.itsbruno.dev",
    image: Nwiz,
  },
  {
    name: "hono-fsr",
    description: {
      en: "File-system router for the Hono web framework.",
      de: "Dateisystem-Router für das Hono-Webframework.",
      hu: "Fájlrendszer-útválasztó a Hono webes keretrendszerhez.",
    },
    repo: "https://github.com/itsbrunodev/hono-fsr#readme",
    demo: "https://npmjs.com/package/hono-fsr",
    image: null,
  },
];
